import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";

import "./styles.css";
import { Card, Table } from "antd";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

const { Column } = Table;

const Metrics = () => {
  const data = [
    {
      sno: 1,
      metric: "Unique Visitors/Visitors\xa0",
      definition:
        "The number of distinct individuals /devices that have visited the website within a specified period.",
    },
    {
      sno: 2,
      metric: "Total Visits",
      definition:
        "A visit or session is a period of interaction that starts when a user enters a website and ends when there is no further activity for a specified duration. Total visits represent the cumulative number of these sessions recorded on a website within a given period.",
    },
    {
      sno: 3,
      metric: "Total Pageviews",
      definition:
        "The aggregate number of times that web pages on a website have been viewed or accessed by visitors within a specified period.",
    },
    {
      sno: 4,
      metric: "Views per visit",
      definition:
        "The average number of pages viewed by a visitor during a single session or visit to a website.",
    },
    {
      sno: 5,
      metric: "Bounce Rate",
      definition:
        "The percentage of visitors to a website who leave after viewing only one page.",
    },
    {
      sno: 6,
      metric: "Visit Duration",
      definition:
        "The average time that a visitor spends on a website during a single session or visit.",
    },
    {
      sno: 7,
      metric: "Unique Entrances",
      definition:
        "The number of times a specific page is the first page viewed by a visitor during a session or visit to a website.",
    },
    {
      sno: 8,
      metric: "Unique Exits",
      definition:
        "The count of sessions in which a specific page was the final page visited by a user before leaving the website.",
    },
    {
      sno: 9,
      metric: "Page Views",
      definition:
        "The total number of times a specific web page has been viewed by users within a specified period.",
    },
    {
      sno: 10,
      metric: "Subscribed Users",
      definition:
        "The individuals who have opted in to receive communications, updates, or services from a website or platform by providing their email addresses or other contact information and explicitly agreeing to be subscribed.",
    },
    {
      sno: 11,
      metric: "Returning Users",
      definition:
        "The individuals who have visited a website or platform on multiple occasions within a specified period.",
    },
    {
      sno: 12,
      metric: "Conversion Rate",
      definition:
        "The percentage of visitors who became subscribers out of the total number of visitors to the website or landing page within a specified period.",
    },
    {
      sno: 13,
      metric: "UTM source/Medium",
      definition:
        "UTM source: The source that referred the traffic to a website. E.g., Facebook, Twitter. UTM Medium: The category of the source that referred the traffic to a website. E.g., Social, Direct",
    },
    {
      sno: 14,
      metric: "Referrer",
      definition:
        "The URL of the web page that the user was on before navigating to the current page.",
    },
    {
      sno: 15,
      metric: "Total Plays",
      definition: "The cumulative number of times video content is watched.",
    },
    {
      sno: 16,
      metric: "Play Rate",
      definition: "The percentage of total plays to total page views.",
    },
    {
      sno: 17,
      metric: "Total Views",
      definition:
        "The cumulative number of times a piece of content has been viewed by users within a specified period.",
    },
    {
      sno: 18,
      metric: "Unique Views",
      definition:
        "The number of individual users who have accessed or viewed a particular piece of content within a specified period.",
    },
    {
      sno: 19,
      metric: "Total Watch Time",
      definition:
        "The cumulative time users spend on watching the Video content.",
    },
    {
      sno: 20,
      metric: "Average Watch Time",
      definition: "The average time users spend watching the video content.",
    },
  ];
  return (
    <Card className="reports-wrapper" title={"Metric Definitions"}>
      <div>
        <Table size="small" dataSource={data} pagination={false}>
          <Column title="S.no" dataIndex={"sno"} align="center" />
          <Column title="Metric" dataIndex={"metric"} align="center" />
          <Column title="Definition" dataIndex={"definition"} align="left" />
        </Table>
      </div>
    </Card>
  );
};

export default Metrics;
